import React from 'react';

// styles
import { HeroWrapper } from './Hero.styles';

export function Hero({ images }) {
    return <HeroWrapper bg={images} />;
}
